import { render } from "./PaneSample.vue?vue&type=template&id=14c1425a&scoped=true&ts=true"
import script from "./PaneSample.vue?vue&type=script&lang=ts"
export * from "./PaneSample.vue?vue&type=script&lang=ts"

import "./PaneSample.vue?vue&type=style&index=0&id=14c1425a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14c1425a"]])

export default __exports__